import { RootState } from '@redux/types';

export const castingSessionIdSelector = (state: RootState) => state.casting.castingSessionId;
